import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class InsightsService {
  FB_AppID: string = '7881124921929574';
  
  constructor(private http: HttpClient) { }
  
  getSettings(): any {
    return this.http.get<any>(environment.app.apiUrl + 'insights/settings').toPromise();
  }
  saveSettings(settings: any): any {
    return this.http.post<any>(environment.app.apiUrl + 'insights/settings/save', settings).toPromise();
  }
  exchangeToken(accessToken: string, userId) {
    return this.http.post<any>(environment.app.apiUrl + 'insights/exchange-token',  {accessToken, userId}).toPromise();
  }
  apiRequest(apiUrl: string) {
    return this.http.post<any>(environment.app.apiUrl + 'insights/api-request',  {apiUrl}).toPromise();
  }
  debugToken(accessToken: string): any {
    return this.http.post<any>(environment.app.apiUrl + 'insights/debug-token',  {accessToken}).toPromise();
  }
  dumpIgPage(username: string): any {
    return this.http.get<any>(environment.app.apiUrl + 'insights/dump-ig-page/' + username).toPromise();
  }
  getIgPageInsights(): any {
    return this.http.get<any>(environment.app.apiUrl + 'insights/get-ig-insights/').toPromise();
  }
  updateIgPages(): any {
    return this.http.get<any>(environment.app.apiUrl + 'insights/update-ig-pages').toPromise();
  }

}
